export function viewerRefreshIntervalMs(value: string | undefined): number {
  const seconds = Number(value)
  return Number.isInteger(seconds) && seconds >= 1 && seconds <= 86400 ? seconds * 1000 : 30000
}
